import { useLayoutEffect } from "react";
import "./animaciones.css";

const CLASES = ["anim", "anim-izq", "anim-der", "anim-subir", "anim-zoom", "anim-visible"];

// Animaciones de entrada: cada grupo aparece con movimiento cuando llega a la pantalla al hacer scroll.
// animaciones: lista de { selector, tipo, escalonar }
//   tipo: de dónde viene (subir, izq, der, zoom)
//   escalonar: los elementos del grupo entran uno tras otro; con un número N, el escalonado se repite cada N
//   elementos (por ejemplo 2 en una grilla de 2 columnas, para que los de abajo no esperen de más)
//   inicio: segundos que espera el grupo antes de empezar (para que entre después de otro grupo)
// raiz: selector que se antepone a cada selector (por ejemplo ".promo")
// Los elementos se buscan una sola vez al montar la página: no sirve para contenido que se carga después.
export const useAnimacionesAlScroll = (animaciones, raiz = "") => {
  // useLayoutEffect: se marcan los elementos antes de que el navegador pinte, así no parpadean
  useLayoutEffect(() => {
    const sinMovimiento = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (sinMovimiento || !("IntersectionObserver" in window)) return undefined;

    const observador = new IntersectionObserver(
      (entradas) =>
        entradas.forEach((entrada) => {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add("anim-visible");
          observador.unobserve(entrada.target);
        }),
      { threshold: 0.15 }
    );

    const marcados = [];
    animaciones.forEach(({ selector, tipo, escalonar, inicio = 0 }) => {
      const completo = selector
        .split(",")
        .map((parte) => `${raiz} ${parte.trim()}`.trim())
        .join(", ");
      document.querySelectorAll(completo).forEach((el, i) => {
        el.classList.add("anim", `anim-${tipo}`);
        const ciclo = escalonar === true ? Infinity : Number(escalonar) || 1;
        el.style.setProperty("--retraso", `${inicio + (escalonar ? (i % ciclo) * 0.12 : 0)}s`);
        observador.observe(el);
        marcados.push(el);
      });
    });

    return () => {
      observador.disconnect();
      marcados.forEach((el) => el.classList.remove(...CLASES));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
